import { render, staticRenderFns } from "./modalEditApiAlerts.vue?vue&type=template&id=5a77dab1&"
import script from "./modalEditApiAlerts.vue?vue&type=script&lang=js&"
export * from "./modalEditApiAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports